var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHashtagCircle = function SvgHashtagCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#556575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.467 10.3.766-4.6M8.768 10.3l.766-4.6M10.534 6.867H5.867M10.134 9.133H5.467M12.243 3.757a6 6 0 1 1-8.485 8.486 6 6 0 0 1 8.485-8.486"
  })));
};
export { SvgHashtagCircle as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMDE1ZjY3OTk5NmZmYzkzNzMwODY0NjIwNWNmZWE4NTYuc3ZnIjs=";